import './assets/css/Invoice.scss'
import React, {Dispatch, SetStateAction, useEffect, useState} from "react";
import AppSettingController from "../Main/controller/AppSettingController";
import MarketSetting from "../Main/interface/MarketSettingLocalStorage";
import SelectDesk from "./components/SelectDesk";
import InvoiceInterface from "./interface/invoiceInterface";
import InvoiceState from "./interface/invoiceState";
import InvoiceList from './components/InvoiceList';

export default function Invoice({data, setData}: {
    data: InvoiceInterface,
    setData: Dispatch<SetStateAction<InvoiceInterface>>
}) {
    const setting = AppSettingController.getSetting() as MarketSetting;
    const [state, setState] = useState<InvoiceState>({
        takeaway: false,
        loading: false
    })

    useEffect(() => {
        // validate number invoice in first time
        AppSettingController.checkInvoiceNum()
    }, []);

    if (!setting.activeDesk)
        return <InvoiceList data={state} setData={setState} state={data} setState={setData}/>

    if (state.takeaway || state.deskActive?.id)
        return <InvoiceList data={state} setData={setState} state={data} setState={setData}/>

    return (
        <SelectDesk state={state} setState={setState}/>
    );
}